import { configsUnification } from 'src/config/configs.unification';
import {
  Environment,
  environment,
  isLocalNeighbors,
  isLocalNpss,
} from 'src/utils/constants';
import { beta } from './config.beta';
import { gamma } from './config.gamma';
import { prod } from './config.prod';
import { Config } from './types';

const CONFIG_BY_ENVIRONMENT: Record<Environment, Config> = {
  prod,
  qa: gamma,
  dev: beta,
};

/**
 * Map a resolved {@link Environment} to its {@link Config}. The environment is
 * the single source of truth (see resolveEnvironment in src/utils/constants), so
 * the config can never disagree with the isProd/isQA/isDev flags derived from the
 * same value (NHVERTICAL-6316).
 */
export const getConfigForEnvironment = (env: Environment): Config =>
  CONFIG_BY_ENVIRONMENT[env];

// Local redirect hosts use the unification config; every other host maps to its
// environment's config. The `?? beta` keeps `config` defined even when a unit
// test mocks src/utils/constants without an `environment`.
export const config: Config =
  isLocalNpss || isLocalNeighbors
    ? configsUnification
    : CONFIG_BY_ENVIRONMENT[environment] ?? beta;
